import { AddressElement, PaymentElement } from '@stripe/react-stripe-js';
import cn from 'classnames';

import { TEMPO } from 'context/BrandContext';
import useBrand from 'hooks/useBrand';

/**
 *
 *
 * Must be a child of a <StripeElements> component
 * Read more: https://stripe.com/docs/stripe-js/react#available-element-components
 *
 */

const StripePaymentElement = ({
  defaultValues = {},
  onChange,
  handleBlur,
  handleFocus,
  variant,
}) => {
  const isTempo = useBrand(TEMPO);
  const isRefreshed = variant === 'refreshed';
  const billingAddressOptions = {
    allowedCountries: ['US'],
    mode: 'billing',
  };

  const paymentOptions = {
    defaultValues: {
      billingDetails: { email: defaultValues.email },
    },
    fields: {
      billingDetails: {
        address: 'never',
      },
    },
    // Apple Pay is handled by the express checkout flow
    wallets: {
      applePay: 'never',
      googlePay: 'never',
    },
  };

  const paymentElement = (
    <PaymentElement
      options={process.env.CYPRESS ? {} : paymentOptions}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );

  return (
    <>
      <AddressElement options={billingAddressOptions} />
      {isRefreshed ? (
        <div
          className={cn(
            'rounded-xl border border-solid bg-white-100 p-4',
            isTempo ? 'border-charcoal-60' : 'border-cream-120'
          )}
        >
          {paymentElement}
        </div>
      ) : (
        paymentElement
      )}
    </>
  );
};

StripePaymentElement.propTypes = {
  defaultValues: PropTypes.object,
  onChange: PropTypes.func,
  handleFocus: PropTypes.func,
  handleBlur: PropTypes.func,
  variant: PropTypes.oneOf(['refreshed']),
};

export default StripePaymentElement;
